(() => {
  "use strict";

  if (customElements.get("recently-viewed")) return;

  customElements.define(
    "recently-viewed",
    class extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest("[data-section-id]");
        this.howManyToShow = parseInt(this.dataset.limit, 10) || 3;
        this.target = this.dataset.target;
        this.wrapperId = this.dataset.wrapperId || this.id;
      }

      connectedCallback() {
        if (this.started) return;
        this.started = true;

        const isCartGrid =
          /\/cart\/?$/.test(window.location.pathname) &&
          this.target === "api-product-grid-item";

        if (isCartGrid) {
          this.loadCartProducts().catch((error) => {
            console.error("Recently viewed products:", error);
          });
          return;
        }

        // Preserve the original behavior everywhere else.
        Shopify.Products.showRecentlyViewed({
          howManyToShow: this.howManyToShow,
          wrapperId: this.wrapperId,
          section: this.section,
          target: this.target,
          onComplete: () => this.notifyLoaded(),
        });
      }

      notifyLoaded() {
        this.dispatchEvent(
          new CustomEvent("theme:recently-viewed:loaded", {
            bubbles: false,
          })
        );
      }

      getHandles() {
        const entry = document.cookie
          .split(";")
          .map((value) => value.trim())
          .find((value) =>
            value.startsWith("shopify_recently_viewed=")
          );

        if (!entry) return [];

        try {
          const value = entry.slice(entry.indexOf("=") + 1);
          const handles = decodeURIComponent(value)
            .split(/\s+/)
            .filter(Boolean);

          return [...new Set(handles)].slice(
            0,
            this.howManyToShow
          );
        } catch {
          return [];
        }
      }

      async fetchCard(handle, index, wrapper) {
        const controller = new AbortController();
        const timeout = setTimeout(
          () => controller.abort(),
          12000
        );

        try {
          const root = window.theme.routes.root;
          const url =
            `${root}products/${encodeURIComponent(handle)}` +
            `?section_id=${encodeURIComponent(this.target)}`;

          const response = await fetch(url, {
            signal: controller.signal,
          });

          if (!response.ok) return "";

          const html = await response.text();
          const container = document.createElement("div");

          container.innerHTML = html
            .replaceAll("||itemAnimationDelay||", index * 100)
            .replaceAll(
              "||itemAnimationAnchor||",
              `#${wrapper.id}`
            );

          return (
            container.querySelector("[data-api-content]")
              ?.innerHTML || ""
          );
        } catch {
          // A failed request must not prevent other cards loading.
          return "";
        } finally {
          clearTimeout(timeout);
        }
      }

      async loadCartProducts() {
        if (Shopify.visualPreviewMode) return;

        const wrapper = document.getElementById(this.wrapperId);
        if (!wrapper) return;

        const handles = this.getHandles();

        for (let start = 0; start < handles.length; start += 5) {
          const batch = handles.slice(start, start + 5);

          // Fetch this batch concurrently, preserving its order.
          const cards = await Promise.all(
            batch.map((handle, index) =>
              this.fetchCard(handle, start + index, wrapper)
            )
          );

          if (!this.isConnected) return;

          const markup = cards.join("");
          if (!markup) continue;

          const slider = this.querySelector("grid-slider");

          // Refresh slider observers when adding the next batch.
          if (wrapper.children.length && slider?.destroy) {
            slider.destroy();
          }

          wrapper.insertAdjacentHTML("beforeend", markup);
          wrapper.classList.remove("hidden");

          // Let the theme handle the threshold and carousel.
          this.notifyLoaded();
        }
      }
    }
  );
})();
